import React from "react";
// @ts-ignore
const MapContext = new React.createContext({
    map:null,
    setMap:()=>{}
});
export default MapContext;